import _ from 'lodash'
import LS from '../lib/LSstore'

const actions ={
    //TODO es6 参数解构
    setLoading({commit},platform){
        commit('SET_LOADING',platform)
    },
    setIsMobile({commit},payload){
      commit('SET_IS_MOBILE',payload)
    },
    toggleSide({commit,state},data){
      let payload={};
       payload.siderbarOpen = data?data:(!state.siderbarOpen)
       console.log(state.isMobile)
       if(state.isMobile){
        // commit('TOGGLE_SILDER',true)
       }else{
        commit('TOGGLE_SILDER',payload)
       }
    },
    setUserInfo({commit,state},data){
        let payload =state.userInfo;
        _.assign(payload,data);
        LS.setItem("userInfo",payload)
        commit('SET_USER_INFO',payload)
    },
    setDeviceInfo({commit,state},data){
      let payload =data;
      if(payload.device_id&&payload.device_id.$oid){
        payload.device_id=payload.device_id.$oid
      }
      LS.setItem("deviceInfo",payload)
      commit('SET_DEVICE_INFO',payload)
  },
  setDeviceListType({commit},payload){
    LS.setItem("deviceListType",payload)
    commit('SET_DEVICE_LIST_TYPE',payload)
  },
    setStandData({commit},payload){
        commit('SET_STAND_DATA',payload)
    },
    setPlayerData({commit},payload){
      commit('SET_PLAYER_DATA',payload)
  },

}

export default actions



// WEBPACK FOOTER //
// ./src/store/action.js